import type { TableView } from '../index';

// Determines whether in virtual select all mode with an exclusion list.
export default function isInVirtualSelectionExclusionMode(tableView: TableView): boolean {
    const { isInVirtualSelectAllMode, virtualSelectAllExclusionList } = tableView;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (9,40): Object is possibly 'undefined'.
    // @ts-expect-error
    return isInVirtualSelectAllMode && virtualSelectAllExclusionList.length > 0;
}
